import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { MultiSelect, MultiSelectProps, SelectMode } from '../multi-select';
import { Badge } from '../../atoms/Badge/Badge';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

const options = (t: TFunction<'designSystem'>) => [
  {
    value: 'true',
    label: <Badge status="bad" label={t('common:yes')} />,
  },
  {
    value: 'false',
    label: <Badge status="good" label={t('no')} />,
  },
];
export const CriticalStatusFilter = ({
  icon,
  label,
  setValue,
  value,
  mode,
  wrapperClassName,
  dataTestId,
  ...props
}: Omit<
  MultiSelectProps<ReturnType<typeof options>[number]>,
  'options' | 'mode' | 'label' | 'value' | 'setValue'
> &
  SelectMode & { label?: string; wrapperClassName?: string }) => {
  const { t } = useTranslation('designSystem');
  return (
    <MultiSelect
      {...props}
      icon={icon || ExclamationCircleIcon}
      label={label || t('common:status')}
      options={options(t)}
      mode={mode}
      setValue={setValue as any}
      value={value as any}
      className={`h-[40px]`}
      displayButtonClassName={wrapperClassName}
      dataTestId={dataTestId}
    />
  );
};
